import {
  TextField,
  Typography,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { useState } from "react";

function ChooseIEBFileModal({ open, onClose, rowData }) {
  const [selectedIEB, setSelectedIEB] = useState(rowData.IEBDate || null);

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onClose(rowData.local, selectedIEB);
  };

  const handleFileSelection = (e, chosenFile) => {
    setSelectedIEB(chosenFile);
  };

  const IEBfile = () => {
    if (selectedIEB) {
      return <Typography sx={{ fontWeight: "500" }}>{selectedIEB}</Typography>;
    } else {
      return <Typography>No file selected</Typography>;
    }
  };

  return (
    <Dialog
      data-testid="IEB-choose-file-modal"
      slotProps={{
        paper: {
          sx: {
            width: "80%",
            height: "auto", // allow height to be determined by content
            maxHeight: "90vh", // prevent it from going off-screen
            overflowY: "visible", // ensure the Paper itself doesn't clip content
          },
        },
      }}
      open={open}
    >
      <DialogTitle>Local {rowData.local}</DialogTitle>
      <DialogContent sx={{ overflowY: "visible", display: "block" }}>
        <Box sx={{ display: "flex" }}>
          <Typography>Current IEB file:&nbsp;</Typography>
          <IEBfile />
        </Box>

        {rowData.files.length ? (
          <Autocomplete
            data-testid="select-IEB-file"
            disablePortal
            options={[...rowData.files].sort(
              (a, b) => new Date(b) - new Date(a)
            )}
            getOptionLabel={(option) => option || ""}
            slotProps={{
              listbox: {
                sx: {
                  maxHeight: 300,
                  position: "relative", // This helps 'push' the container down
                },
              },
            }}
            sx={{ width: 300, marginTop: "12px" }}
            renderInput={(params) => (
              <TextField {...params} label="Select a file" />
            )}
            onChange={handleFileSelection}
            value={selectedIEB}
          />
        ) : (
          <Box
            sx={{
              border: "1px solid #dfdede",
              borderRadius: "3px",
              padding: "12px",
              backgroundColor: "#f5f5f5",
              color: "#000000b3",
              marginTop: "6px",
            }}
          >
            <Typography>
              {rowData.local} has no eligible files for IEB selection.
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        {/* Focus the safe (cancel) button so a keyboard Enter doesn't trigger Ok */}
        {/* eslint-disable-next-line jsx-a11y/no-autofocus */}
        <Button className="siteBlueOutlined" autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          className="siteBlue"
          onClick={handleOk}
          disabled={!rowData.files.length}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ChooseIEBFileModal;
